// material-ui
import { alpha, createTheme } from '@mui/material/styles';

// third-party
import { presetPalettes } from '@ant-design/colors';

// project imports
import ThemeOption from './theme';

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode, presetColor) {
  const colors = presetPalettes;
  const brandMain = '#0082C2';
  const brandFilled = '#007BB8';
  const brandHover = '#006A9C';
  const brandAccent = '#00AEEF';

  let greyPrimary = [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#262626',
    '#141414',
    '#000000'
  ];
  let greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
  let greyConstant = ['#fafafb', '#e6ebf1'];

  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = ThemeOption(colors, presetColor, mode);
  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff'
      },
      ...paletteColor,
      text: {
        primary: paletteColor.grey[700],
        secondary: paletteColor.grey[500],
        disabled: paletteColor.grey[400]
      },
      action: {
        disabled: paletteColor.grey[300]
      },
      divider: paletteColor.grey[200],
      background: {
        paper: paletteColor.grey[0],
        default: paletteColor.grey.A50
      },
      vrp: {
        brand: brandAccent,
        primary: brandMain,
        primaryFilled: brandFilled,
        primaryHover: brandHover,
        primaryHoverBg: alpha(brandHover, 0.08),
        primarySelectedBg: alpha(brandMain, 0.12),
        primarySubtleBg: alpha(brandMain, 0.08),
        focusRing: alpha(brandFilled, 0.2),
        borderStrong: paletteColor.grey[300]
      }
    }
  });
}
